import { Boxes, MessageSquare, ShieldCheck } from "lucide-react";
import ApplicationCard from "../components/ApplicationCard";
import Loader from "../components/Loader";
import { useApplicationsContext } from "../context/ApplicationsContext";
import { useAuth } from "../context/AuthContext";

export default function Dashboard() {
  const { applications, loading, error } = useApplicationsContext();
  const { user } = useAuth();

  const stats = [
    { icon: Boxes, label: "اپلیکیشن‌ها", value: applications.length },
    { icon: MessageSquare, label: "گفت‌وگوهای فعال", value: 0 },
    { icon: ShieldCheck, label: "سطح دسترسی", value: user?.is_admin ? "مدیر" : "کاربر" },
  ];

  return (
    <>
      <div className="page-head">
        {/* No emoji here on purpose: the vendored Vazirmatn carries no emoji glyphs. */}
        <h1>سلام{user?.full_name ? `، ${user.full_name}` : ""}</h1>
        <p>اپلیکیشنی را انتخاب کنید تا گفت‌وگو با ایجنت آن را شروع کنید.</p>
      </div>

      <div className="stat-row">
        {stats.map((stat) => (
          <div className="card stat" key={stat.label}>
            <span className="stat-icon" aria-hidden="true">
              <stat.icon size={19} strokeWidth={1.8} />
            </span>
            <div>
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="section-head">
        <h2>اپلیکیشن‌ها</h2>
        <span>{applications.length} مورد</span>
      </div>

      {loading && <Loader message="در حال دریافت اپلیکیشن‌ها…" />}

      {!loading && error && <div className="alert alert-error">{error}</div>}

      {!loading && !error && applications.length === 0 && (
        <div className="card state">
          <div className="state-icon" aria-hidden="true">
            <Boxes size={30} strokeWidth={1.7} />
          </div>
          <p>هنوز اپلیکیشنی ثبت نشده است.</p>
        </div>
      )}

      {!loading && !error && applications.length > 0 && (
        <div className="app-grid">
          {applications.map((application) => (
            <ApplicationCard key={application.id} application={application} />
          ))}
        </div>
      )}
    </>
  );
}
